import * as React from 'react';
import { IconProps } from '../types';

const IcCopy = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
   <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M2.317 7.63c0-1.028.806-1.824 2.02-1.824 1.213 0 3.704-.027 3.704-.027s-.038-.857-.038-1.946C8.003 2.743 8.99 2 10.175 2c1.185 0 7.052.05 7.628.05.576 0 1.043.21 1.689.694.645.484 1.62 1.294 2.104 1.833.483.54.687.854.687 1.3 0 .444 0 9.416-.008 10.455-.007 1.04-.978 1.808-2.128 1.823-1.15.015-3.618.015-3.618.015s.058.77.058 1.857-1.007 1.937-2.15 1.967c-1.145.03-8.936-.06-10.046-.03-1.11.03-2.108-.833-2.108-1.89s.034-11.416.034-12.444Zm2.078.484L4.252 19.49a.48.48 0 0 0 .302.454c.06.025.124.038.19.038l9.179.027a.486.486 0 0 0 .453-.3.468.468 0 0 0 .033-.188l-.027-1.09a.24.24 0 0 0-.159-.222.25.25 0 0 0-.096-.016s-2.715.078-3.945.035c-1.23-.042-2.07-.834-2.07-1.9V7.856a.24.24 0 0 0-.154-.226.25.25 0 0 0-.096-.018l-2.964.01a.51.51 0 0 0-.353.145.496.496 0 0 0-.15.347Zm13.228-4.32c-.207-.178-.375-.103-.375.168v2.114c0 .136.111.246.248.247l2.592.012c.273.002.328-.141.12-.319l-2.585-2.222Zm-7.155.104a.251.251 0 0 0-.23.15.243.243 0 0 0-.02.093L10.14 15.94a.359.359 0 0 0 .107.26.368.368 0 0 0 .262.107l9.34-.023c.066 0 .13-.026.178-.072a.25.25 0 0 0 .076-.174l.157-7.648a.235.235 0 0 0-.069-.174.242.242 0 0 0-.174-.071l-3.823.005c-.573 0-.936-.273-.936-.795 0-.521-.011-3.18-.011-3.18a.248.248 0 0 0-.074-.175.254.254 0 0 0-.176-.073l-4.529-.028Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcCopy;